// extracted by mini-css-extract-plugin
export default {"dialogText":"NewOrderDialog_dialogText__NftnO"};